import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";

export const SliderField = ({ id, label, value, min, max, step = 1, unit = "", onChange, disabled }) => (
  <div className={`space-y-2 ${disabled ? "opacity-40" : ""}`}>
    <div className="flex items-center justify-between">
      <label htmlFor={id} className="text-xs text-zinc-300">{label}</label>
      <span className="font-mono text-[11px] text-zinc-400" data-testid={`${id}-value`}>
        {Number(value).toFixed(step < 1 ? (step < 0.1 ? 2 : 1) : 0)}{unit}
      </span>
    </div>
    <Slider
      id={id}
      data-testid={`${id}-slider`}
      aria-label={label}
      value={[value]}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      onValueChange={([v]) => onChange(v)}
      className="[&_[role=slider]]:h-3.5 [&_[role=slider]]:w-3.5 [&_[role=slider]]:border-[#ff5a00] [&_[role=slider]]:bg-white [&>span:first-child]:bg-white/10 [&>span:first-child>span]:bg-[#ff5a00]"
    />
  </div>
);

export const SwitchField = ({ id, label, hint, checked, onChange, disabled }) => (
  <div className={`flex items-start justify-between gap-3 ${disabled ? "opacity-40" : ""}`}>
    <label htmlFor={id} className="text-xs text-zinc-300">
      {label}
      {hint && <span className="block text-[11px] text-zinc-500 mt-0.5">{hint}</span>}
    </label>
    <Switch id={id} data-testid={`${id}-switch`} checked={checked} disabled={disabled} onCheckedChange={onChange} />
  </div>
);

export const Segmented = ({ id, options, value, onChange }) => (
  <div className="grid gap-1 p-1 rounded-lg bg-black/40 border border-white/5" style={{ gridTemplateColumns: `repeat(${options.length}, 1fr)` }} role="radiogroup">
    {options.map((o) => (
      <button
        key={String(o.value)}
        type="button"
        role="radio"
        aria-checked={value === o.value}
        data-testid={`${id}-${o.value}`}
        onClick={() => onChange(o.value)}
        className={`text-[11px] py-1.5 rounded-md font-medium transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff5a00] ${
          value === o.value ? "bg-[#ff5a00] text-white" : "text-zinc-400 hover:text-white hover:bg-white/5"
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export const Section = ({ title, children, right }) => (
  <section className="space-y-4">
    <div className="flex items-center justify-between">
      <h3 className="eyebrow">{title}</h3>
      {right}
    </div>
    {children}
  </section>
);
